import { Link, isRouteErrorResponse, useRouteError } from "react-router";

export function ErrorState({ error, onRetry }: { error: Error; onRetry?: () => void }) {
  return (
    <div className="page">
      <div className="centered-state">
        <h1>Impossible d'afficher cette page</h1>
        <p>{error.message}</p>
        <div className="actions">
          {onRetry && (
            <button type="button" className="button" onClick={onRetry}>
              Réessayer
            </button>
          )}
          <Link className="button button--quiet" to="/">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}

export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  console.error(error);
  return (
    <ErrorState
      error={new Error("Une erreur inattendue est survenue. Rechargez la page.")}
      onRetry={() => window.location.reload()}
    />
  );
}

export function NotFound() {
  return (
    <div className="page">
      <div className="centered-state">
        <h1>Cette page n'existe pas</h1>
        <p>Le lien est peut-être incomplet. Vérifiez l'adresse ou repartez de l'accueil.</p>
        <div className="actions">
          <Link className="button" to="/">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
